export const FirebaseConfig = {
	"apiKey": "AIzaSyB-KgXUSAWuirHlbTcgp2-sGIDJ-fjmTns",
	"authDomain": "guru-assistencia.firebaseapp.com",
	"databaseURL": "https://guru-assistencia-default-rtdb.firebaseio.com",
	"projectId": "guru-assistencia",
	"storageBucket": "guru-assistencia.firebasestorage.app",
	"messagingSenderId": "794183129312",
	"appId": "1:794183129312:web:65e4dc6ad5561f97b45885",
	"measurementId": "G-FV9769J4GY"
}; 